import { fetchTopScores } from '../monetization/leaderboard';
import { readBestScore } from '../utils/storage';

export function refreshSidePanelBest(best?: number): void {
  if (typeof document === 'undefined') {
    return;
  }
  const element = document.getElementById('panel-best');
  if (!element) {
    return;
  }
  const value = best === undefined ? readBestScore() : best;
  element.textContent = value > 0 ? String(value) : '—';
}

function escapeHtml(value: string): string {
  return value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;');
}

export async function refreshSidePanelLeaderboard(): Promise<void> {
  if (typeof document === 'undefined') {
    return;
  }
  const list = document.getElementById('panel-top-scores');
  if (!list) {
    return;
  }
  const scores = await fetchTopScores(5);
  if (scores.length === 0) {
    list.innerHTML = '<li class="score-empty">no scores yet — be the first</li>';
    return;
  }
  list.innerHTML = scores
    .map(
      (row) =>
        `<li><span class="score-rank">#${row.rank}</span><span class="score-name">${escapeHtml(
          row.name,
        )}</span><span class="score-points">${row.score}</span></li>`,
    )
    .join('');
}
